export default __webpack_public_path__ + "static/media/OSMOS_CENERE_C2_GRIP_60X120_07.07c9e267.jpg";